import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function StatusBadge({ status }) {
  const cls =
    status === "completed"
      ? "bg-emerald-500/20 text-emerald-400"
      : status === "failed"
      ? "bg-red-500/20 text-red-400"
      : "bg-amber-500/20 text-amber-400";
  return <Badge className={cls}>{status}</Badge>;
}

export function ExtractionHistory({ runs, onRetry, retryingId }) {
  if (!runs.length) {
    return (
      <Card className="bg-slate-900/50 border-slate-800">
        <CardHeader><CardTitle>Extraction History</CardTitle></CardHeader>
        <CardContent><div className="text-slate-500 text-sm">No runs yet</div></CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-slate-900/50 border-slate-800">
      <CardHeader><CardTitle>Extraction History</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800">
              <TableHead className="text-slate-400">Country</TableHead>
              <TableHead className="text-slate-400">State</TableHead>
              <TableHead className="text-slate-400">Status</TableHead>
              <TableHead className="text-slate-400">Found</TableHead>
              <TableHead className="text-slate-400">Inserted</TableHead>
              <TableHead className="text-slate-400">Notes</TableHead>
              <TableHead className="text-slate-400" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {runs.slice(0, 10).map((r) => (
              <TableRow key={`run-${r.id}`} data-testid={`run-row-${r.id}`} className="border-slate-800">
                <TableCell>{r.country}</TableCell>
                <TableCell>{r.first_level_name || "-"}</TableCell>
                <TableCell><StatusBadge status={r.status} /></TableCell>
                <TableCell className="font-mono">{r.total_extracted?.toLocaleString() || "-"}</TableCell>
                <TableCell className="font-mono">{r.total_inserted?.toLocaleString() || "-"}</TableCell>
                <TableCell className="max-w-[200px] truncate text-xs" title={r.notes || ""}>
                  {r.status === "failed" ? (
                    <span className="text-red-400/70">{r.notes || "Unknown"}</span>
                  ) : r.notes ? (
                    <span className="text-slate-500">{r.notes}</span>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>
                  {r.status === "failed" && (
                    <Button
                      data-testid={`btn-retry-${r.id}`}
                      variant="outline"
                      size="sm"
                      onClick={() => onRetry(r.id)}
                      disabled={retryingId === r.id}
                      className="border-slate-700 text-xs"
                    >
                      {retryingId === r.id ? "Retrying..." : "Retry"}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
